var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoPage',[_c('h1',{staticClass:"display-2 mt-2 mt-md-6 mt-lg-12 mb-6 text-center"},[_vm._v(_vm._s(_vm.$t("formulaireDon.remerciementTitre")))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('formulaireDon.remerciementParagrapheMensuel'))}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('transactionRealisee'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }